export default "__VITE_ASSET__c1f7dc0a__"